import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-23137_add-tiered-interventions-to-learn'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
